import React, { useState, useCallback } from 'react';
import {SIFReportingCompanies, SIFFilter} from '../'
import { groupBy } from '../../utils/miscUtil';
import { Chart, Series, Legend, Label, Tooltip,
  ArgumentAxis, ValueAxis} from 'devextreme-react/chart';
import { Button } from 'devextreme-react/button';

const colors = ['#ec5020', '#00a2c8', '#5cc2d7'];

export default function SIFDisciplineActivityTask(props) {
  const [level, setLevel] = useState(0);
  const [title, setTitle] = useState('Disciplines');
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [currentDiscipline, setCurrentDiscipline] = useState(null);

  const onFilterDataChanged = useCallback((data) => {
    console.log(data);
    setFilteredData(data);
    setLevel(0);
    var fd = groupBy(data, 'Discipline of Activity at Time of Event')
    fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
    fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
    setData(fd);

  }, []);

  const customizePoint = useCallback(
    () => ({
      color: colors[Number(level)],
      hoverStyle: level !== 2
        ? {
          hatching: 'none',
        }
        : {},
    }),
    [level],
  );
  const onPointClick = useCallback(
    (e) => {
      if (level === 0) {
        setLevel(1);
        setCurrentDiscipline(e.target.originalArgument.toString());
        let fd = filteredData.filter((item) => item['Discipline of Activity at Time of Event'] === e.target.originalArgument.toString());
        fd = groupBy(fd,'Activity at Time of Event')
        fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
        fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
        setData(fd);
        setTitle('Activities for: '+e.target.originalArgument.toString())
      }
      if (level === 1) {
        setLevel(2);
        let fd = filteredData.filter((item) => (item['Discipline of Activity at Time of Event'] === currentDiscipline) && (item['Activity at Time of Event'] === e.target.originalArgument.toString()));
        fd = groupBy(fd,'Activity Subgroup or Task')
        fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
        fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
        setData(fd);
        setTitle('Sub-activities for: '+ currentDiscipline +" / " + e.target.originalArgument.toString())
      }
    },
    [level, setData, setLevel, filteredData, currentDiscipline],
  );
  const onButtonClick = useCallback(() => {
    if (level === 1) {
      setLevel(0);
      setCurrentDiscipline(null);
      var fd = groupBy(filteredData, 'Discipline of Activity at Time of Event')
      fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
      fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0))
      setData(fd);
      setTitle('Disciplines')
    }
    if (level === 2) {
      setLevel(1);
      let fd = filteredData.filter((item) => item['Discipline of Activity at Time of Event'] === currentDiscipline);
      fd = groupBy(fd,'Activity at Time of Event')
      fd = Object.keys(fd).map((key) => ({arg: key, value: fd[key].length}));
      fd = fd.sort((a,b) => (a.value > b.value) ? 1 : ((b.value > a.value) ? -1 : 0));
      setData(fd);
      setTitle('Activities for: '+currentDiscipline)
    }
  }, [level, setData, setLevel, filteredData, currentDiscipline]);

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}</div><div class="tooltip-body">`
    txt = txt+`<div>Events: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  return (
    <div>
      <SIFFilter
        data={props.data}
        startDate={props.startDate}
        endDate={props.endDate}
        onFilteredDataChanged={onFilterDataChanged}
        showArea={true}
        showDisciplines={true}
        showActivities={true}
        showPrimaryFactor={true}
        showPotentialActual={true}
        showCategories={true}
      />
      <h5 className={'mb-2'}>{title}</h5>
      {level === 0 && <p>Click a discipline to see activities</p>}
      {level === 1 && <p>Click an activity to see sub-activities</p>}
      <Button
        className="button-container"
        text="Back"
        icon="chevronleft"
        visible={level !== 0}
        onClick={onButtonClick}
      />
      <Chart
        id="chart"
        customizePoint={customizePoint}
        onPointClick={onPointClick}
        className={level === 0 ? 'pointer-on-bars' : ''}
        dataSource={data}
        rotated={true}

      >
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="inside"
          />
        </ArgumentAxis>
        <Series type="bar"
          argumentField="arg"
          valueField="value">
        >
        </Series>
        <ValueAxis>
          <Label
            wordWrap="breakWord"
            position="outside"
          />
        </ValueAxis>
        <Legend visible={false} />
        <Tooltip
          enabled={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <SIFReportingCompanies data={filteredData}/>

    </div>
  );
}
